var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "sa" }, [
    !_vm.dataloaded ? _c("div", [_vm._v(_vm._s(_vm.$t("loading")))]) : _vm._e(),
    _vm.dataloaded && !_vm.isNewUi
      ? _c("div", { staticClass: "flex-row flex-3 mb-1" }, [
          _c("div", { staticClass: "flex-col flex-1" }, [
            _c("div", { staticClass: "flex-row flex-2 mt-1 mb-1" }, [
              _c(
                "div",
                { staticClass: "flex-col flex-2 label flex-justify-center" },
                [
                  _vm.isGasStorageLabel
                    ? _c("div", [
                        _vm._v(
                          _vm._s(_vm.$t("maintainenceRiskScheduling")) + ":"
                        ),
                      ])
                    : _c("div", [_vm._v(_vm._s(_vm.$t("nomination")) + ":")]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "flex-col flex-6 flex-justify-center pb-1",
                  attrs: { id: "nominationComment" },
                },
                [_vm._v(" " + _vm._s(_vm.sap.nominationComment) + " ")]
              ),
            ]),
            _c("div", { staticClass: "flex-row flex-2 mb-1" }, [
              _c(
                "div",
                { staticClass: "flex-col flex-2 label flex-justify-center" },
                [_vm._v(_vm._s(_vm.$t("opportunities")) + ":")]
              ),
              _c(
                "div",
                {
                  staticClass: "flex-col flex-6 flex-justify-center pb-1",
                  attrs: { id: "opportunitiesComment" },
                },
                [_vm._v(" " + _vm._s(_vm.sap.opportunitiesComment) + " ")]
              ),
            ]),
            _c("div", { staticClass: "flex-row flex-2 mb-1" }, [
              _c(
                "div",
                { staticClass: "flex-col flex-2 label flex-justify-center" },
                [_vm._v(_vm._s(_vm.$t("linksToOtherUniperPnLs")) + ":")]
              ),
              _c(
                "div",
                {
                  staticClass: "flex-col flex-6 flex-justify-center pb-1",
                  attrs: { id: "linksToOtherUniperPnlsComment" },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.sap.linksToOtherUniperPnlsComment) + " "
                  ),
                ]
              ),
            ]),
            _c("div", { staticClass: "flex-row flex-2 mb-1" }, [
              _c(
                "div",
                {
                  staticClass: "flex-col flex-2 label flex-justify-center pb-1",
                },
                [_vm._v(_vm._s(_vm.$t("other")) + ":")]
              ),
              _c(
                "div",
                {
                  staticClass: "flex-col flex-6",
                  attrs: { id: "otherComment" },
                },
                [_vm._v(" " + _vm._s(_vm.sap.otherComment) + " ")]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm.dataloaded && _vm.isNewUi
      ? _c("div", [
          _c("dl", [
            _c("dt", [
              _c("b", [
                _vm.isGasStorageLabel
                  ? _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("maintainenceRiskScheduling")) + ":"
                      ),
                    ])
                  : _c("div", [_vm._v(_vm._s(_vm.$t("nomination")) + ":")]),
              ]),
            ]),
            _c("dd", [
              _c("br"),
              _vm._v(" " + _vm._s(_vm.sap.nominationComment) + " "),
            ]),
            _c("br"),
            _c("dt", [
              _c("b", [_vm._v(_vm._s(_vm.$t("opportunities")) + ":")]),
            ]),
            _c("dd", [
              _c("br"),
              _vm._v(" " + _vm._s(_vm.sap.opportunitiesComment) + " "),
            ]),
            _c("br"),
            _c("dt", [
              _c("b", [_vm._v(_vm._s(_vm.$t("linksToOtherUniperPnLs")) + ":")]),
            ]),
            _c("dd", [
              _c("br"),
              _vm._v(" " + _vm._s(_vm.sap.linksToOtherUniperPnlsComment) + " "),
            ]),
            _c("dt", { staticClass: "sub-title" }, [
              _c("b", [_vm._v(_vm._s(_vm.$t("other")) + ":")]),
            ]),
            _c("dd", [
              _c("br"),
              _vm._v(" " + _vm._s(_vm.sap.otherComment) + " "),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }